import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import DataTable from "../DataTable/DataTable";

export default function CollectionDataTable({ query, getQuery, filters, ...props }) {
	const [data, loading, error] = useCollectionData(getQuery ? getQuery(query) : query);

	return <DataTable data={data} loading={loading} error={error} {...props} />;
}
